import React, { useEffect, useState, useContext } from 'react';
import Loadable from "@loadable/component"
import styled, { ThemeContext } from "styled-components"
// import { DEFAULT_THEME } from "@airasia/phoenix-components/components/Theme/constant"
// import PropTypes from "prop-types"
import Title from "@airasia/phoenix-components/components/Title"
import { getGtmUserType, fireGtmEvent } from "../utils/function"
import { GTM_PROJECT_CATEGORY } from "../utils/constant"
import _ from "lodash";

const BannerWrapper = styled.div`
    text-align: center;
    justify-content: center;
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? `column` : `row`)};
  align-items: ${({ isMobile }) => (isMobile ? `normal` : `center`)};
  padding-top: ${({ isMobile }) => (isMobile ? `25px` : `30px`)};


`
const EmojiScoring = Loadable(() =>
  import("@airasia/phoenix-components/components/EmojiScoring")
)

const Wrapper = styled.div`
    /* background-color: rgb(248, 248, 248); */
    color: black;
    text-align: center;
    justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: ${({ isMobile }) => (isMobile ? `column` : `row`)};
  /* align-items: ${({ isMobile }) => (isMobile ? `normal` : `center`)}; */
  /* padding: 20px; */
  margin-top: 50px;
`
BannerWrapper.displayName = "BannerWrapper"

const Container = styled.div`
  padding: 20px 2px 20px 0px;
  text-align: center;
 `
Container.displayName = "Container"

const translations = {
  "en-gb": {
    title: "How would you rate your experience?",
    max: "Very Satisfied",
    min: "Very Dissatisfied"
  },
  "ms-my": {
    title: "Sila nilai pengalaman anda di laman ini?",
    max: "Amat memuaskan",
    min: "Amat mengecewakan"
  },
  "id-id": {
    title: "Bagaimana pengalaman Anda di halaman ini?",
    max: "Sangat Puas",
    min: "Sangat Tidak Puas"
  },
  "th-th": {
    title: "คุณรู้สึกอย่างไรกับการใช้งานหน้านี้?",
    max: "พอใจมาก",
    min: "ไม่พอใจเป็นอย่างมาก"
  }
}

export default function EmojiScorings(props) {
    const {lang = "en-gb"} = props;
    const [textTranslations] = useState(()=>{
      let hasLangInTranslations = _.has(translations, lang);
      if(hasLangInTranslations){
        return _.get(translations, lang, _.get(translations, "en-gb", {}))
      }else{
        _.get(translations, "en-gb", {})
      }
    })
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 768);
    const updateMedia = () => {
        if (typeof window !== 'undefined') setIsMobile(window.innerWidth <= 768);
    };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateMedia);
    }
    return () => (typeof window !== 'undefined' ? window.removeEventListener('resize', updateMedia) : null);
  }, []);
  const {
    theme,
    backgroundColor,
  } = props
  const themeContext = useContext(ThemeContext)
  const data=[
    {
    emoji_active: 'ANGRY_ACTIVE',
    emoji_inactive: 'ANGRY_INACTIVE',
    value: 1
    },
    {
    emoji_active: 'SAD_ACTIVE',
    emoji_inactive: 'SAD_INACTIVE',
    value: 2
    },
    {
    emoji_active: 'OKAY_ACTIVE',
    emoji_inactive: 'OKAY_INACTIVE',
    value: 3
    },
    {
    emoji_active: 'HAPPY_ACTIVE',
    emoji_inactive: 'HAPPY_INACTIVE',
    value: 4
    },
    {
    emoji_active: 'LOVEDIT_ACTIVE',
    emoji_inactive: 'LOVEDIT_INACTIVE',
    value: 5
    }];
  
    const onEmojiClicked = val => {
      const gtmEvent = {
        event: "trackEventNoEcommerce",
        "eventDetails.category": `emoji scoring`,
        "eventDetails.action": `click`,
        "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${val} | ${getGtmUserType()}`,
      }
  
      fireGtmEvent(gtmEvent)
    }

    return (
    <Container>
        <Wrapper
        theme={themeContext}
        backgroundColor={backgroundColor}
        isMobile={isMobile}>
        <Title
            color="black"
            type="h3"
            marginBottom="mini"
            theme="DEFAULT_THEME"
            textAlign="center"
            accessible
            customProperties={{
              id: "emoji-title",
            }}
          >
            {_.get(textTranslations, "title", "How would you rate your experience on this page?")}
          </Title>
        </Wrapper>
        <BannerWrapper
        theme={themeContext}
        backgroundColor={backgroundColor}
        isMobile={isMobile}>
        {isMobile?(
          <EmojiScoring
            accessible
            data={[...data]}
            fullWidth={false}
            maxText={_.get(textTranslations, "max", "Very Satisfied")}
            minText={_.get(textTranslations, "min", "Very Dissatisfied")}
            onEmojiClicked={onEmojiClicked}
            textColor="greyDark"
            textSize="small"
            theme="AIRASIA_CLASSIC"
            viewPort={"desktop"}
            />
        ):(
        <EmojiScoring
        accessible
        data={[...data]}
        fullWidth={false}
        maxText={_.get(textTranslations, "max", "Very Satisfied")}
        minText={_.get(textTranslations, "min", "Very Dissatisfied")}
        onEmojiClicked={onEmojiClicked}
        textColor="greyDark"
        textSize="small"
        theme="AIRASIA_CLASSIC"
        viewPort="mobile"
        />

    )}
    </BannerWrapper>
    </Container>
    )}
EmojiScorings.defaultProps = {
  // theme: DEFAULT_THEME,
  accessible: true,
  isMobile: false,
  backgroundColor: "primary",
}
